import { render } from "./Stores.vue?vue&type=template&id=28d281d9"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Stores.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d281d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d281d9', __exports__)) {
    api.reload('28d281d9', __exports__)
  }
  
  module.hot.accept("./Stores.vue?vue&type=template&id=28d281d9", () => {
    api.rerender('28d281d9', render)
  })

}


export default __exports__